// Whether the till's order store answers, as the Bosla app's shell tells it
// (#392). The shell keeps the store running and starts it again when it
// stops; while it is starting or down, the till covers itself and offers no
// sale (T22), and carries on when it answers again. A sale the store
// confirmed is in its database, so nothing confirmed is lost meanwhile.

import { watchStore, type StoreStatus } from './shell';

let status = $state<StoreStatus>('starting');

/** The store's status now. Reactive. */
export function storeStatus(): StoreStatus {
	return status;
}

/** Follow the store's status while the till runs in the app. Returns the stop. */
export function followStore(): () => void {
	let stop: (() => void) | null = null;
	let gone = false;
	void watchStore((next) => {
		status = next;
	}).then(
		(release) => {
			if (gone) release();
			else stop = release;
		},
		() => {
			// No shell to follow: nothing covers the till.
			status = 'up';
		},
	);
	return () => {
		gone = true;
		stop?.();
	};
}
